export const WEEK_DAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const WEEK_DAY_LABELS = WEEK_DAYS.map((weekday) => weekday.slice(0, 3));

export const SHIFTS = ['Core Day', 'Core Night', 'Float Day', 'Float Night'];

export const RATE_FIELDS = SHIFTS.map((shift) =>
  WEEK_DAYS.map((weekday) => buildRateKey(weekday, shift))
);

export const ALL_INPUT_KEYS = RATE_FIELDS.flat();

export const CORE_DAY_INPUT_KEYS = RATE_FIELDS[shiftIndex('Core Day')];
export const CORE_NIGHT_INPUT_KEYS = RATE_FIELDS[shiftIndex('Core Night')];
export const FLOAT_DAY_INPUT_KEYS = RATE_FIELDS[shiftIndex('Float Day')];
export const FLOAT_NIGHT_INPUT_KEYS = RATE_FIELDS[shiftIndex('Float Night')];

export const DYNAMIC_RATES_INPUT_KEYS = ['priceRange', 'incentiveIncrement'];

export const SUNDAY_INPUT_KEYS = RATE_FIELDS.map(
  (column) => column[weekdayIndex('sunday')]
);
export const MONDAY_INPUT_KEYS = RATE_FIELDS.map(
  (column) => column[weekdayIndex('monday')]
);
export const TUESDAY_INPUT_KEYS = RATE_FIELDS.map(
  (column) => column[weekdayIndex('tuesday')]
);
export const WEDNESDAY_INPUT_KEYS = RATE_FIELDS.map(
  (column) => column[weekdayIndex('wednesday')]
);
export const THURSDAY_INPUT_KEYS = RATE_FIELDS.map(
  (column) => column[weekdayIndex('thursday')]
);
export const FRIDAY_INPUT_KEYS = RATE_FIELDS.map(
  (column) => column[weekdayIndex('friday')]
);
export const SATURDAY_INPUT_KEYS = RATE_FIELDS.map(
  (column) => column[weekdayIndex('saturday')]
);

function buildRateKey(weekday: string, shift: string) {
  return `${weekday}${shift.replace(' ', '')}IncentiveRate`;
}

function shiftIndex(shiftName: string) {
  return SHIFTS.findIndex((name) => name === shiftName);
}

function weekdayIndex(shiftName: string) {
  return WEEK_DAYS.findIndex((name) => name === shiftName);
}

export const WEEKDAY_KEYS_MODEL = [
  {
    title: 'Sunday',
    keys: SUNDAY_INPUT_KEYS,
  },
  {
    title: 'Monday',
    keys: MONDAY_INPUT_KEYS,
  },
  {
    title: 'Tuesday',
    keys: TUESDAY_INPUT_KEYS,
  },
  {
    title: 'Wednesday',
    keys: WEDNESDAY_INPUT_KEYS,
  },
  {
    title: 'Thursday',
    keys: THURSDAY_INPUT_KEYS,
  },
  {
    title: 'Friday',
    keys: FRIDAY_INPUT_KEYS,
  },
  {
    title: 'Saturday',
    keys: SATURDAY_INPUT_KEYS,
  },
];

export const CORE_FLOAT_KEYS_MODEL = [
  {
    title: 'Core Day',
    keys: CORE_DAY_INPUT_KEYS,
  },
  {
    title: 'Float Day',
    keys: FLOAT_DAY_INPUT_KEYS,
  },
  {
    title: 'Core Night',
    keys: CORE_NIGHT_INPUT_KEYS,
  },
  {
    title: 'Float Night',
    keys: FLOAT_NIGHT_INPUT_KEYS,
  },
];
